module.exports = __webpack_public_path__ + "png/payment-way3.png?ac75ad832ad10927b0de87fa9d6673cf";